import { render } from "./VkConfirmGroupAccess.vue?vue&type=template&id=6e90498a"
import script from "./VkConfirmGroupAccess.vue?vue&type=script&lang=js"
export * from "./VkConfirmGroupAccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__